import { Outlet, RouteObject } from "react-router-dom";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import RouteProtector from "./RouteProtector";

const ChangeNonGemiInfo = lazyWithReload(
  () => import("src/nonGemi/features/changeInfo/ChangeNonGemiInfo"),
);
const NonGemiDashboard = lazyWithReload(
  () => import("src/nonGemi/features/dashboard/NonGemiDashboard"),
);

const ChangeNotificationSettings = lazyWithReload(
  () => import("../firebase/features/ChangeNotificationSettings"),
);

export const nonGemiPaths: RouteObject = {
  path: "/nonGemi",
  element: <Outlet />,
  children: [
    {
      path: "dashboard",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <NonGemiDashboard />
        </RouteProtector>
      ),
    },
    {
      path: "changeInfo",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <ChangeNonGemiInfo />
        </RouteProtector>
      ),
    },
    {
      path: "changeNotificationSettings",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <ChangeNotificationSettings />
        </RouteProtector>
      ),
    },
  ],
};
